import { SortOrder, defaults, entities, getAPIMethod } from 'typed/api';
import { ExtractAction, action, entityActionSet, networkAction } from './utils';

export const
    { loadAll: loadAllPerformanceManagementAlertActivityStatuses } = entityActionSet(defaults.PerformanceManagementAlertActivityStatus, {
        loadAll: networkAction('LOAD_ALL_PERFORMANCE_MANAGEMENT_ALERT_ACTIVITY_STATUSES', getAPIMethod('PerformanceManagementAlertActivityStatus', 'loadAll'))
    }),

    { loadAll: loadAllPerformanceManagementAlertTriggerTypes } = entityActionSet(defaults.PerformanceManagementAlertTriggerType, {
        loadAll: networkAction('LOAD_ALL_PERFORMANCE_MANAGEMENT_ALERT_TRIGGER_TYPES', getAPIMethod('PerformanceManagementAlertTriggerType', 'loadAll'))
    }),

    { loadAll: loadAllPerformanceManagementAlertScores } = entityActionSet(defaults.PerformanceManagementAlertScore, {
        loadAll: networkAction('LOAD_ALL_PERFORMANCE_MANAGEMENT_ALERT_SCORES', getAPIMethod('PerformanceManagementAlertScore', 'loadAll'))
    }),

    { loadAll: loadAllPerformanceManagementAlertEmailTitleTypes } = entityActionSet(defaults.PerformanceManagementAlertEmailTitleType, {
        loadAll: networkAction('LOAD_ALL_PERFORMANCE_MANAGEMENT_ALERT_EMAIL_TITLE_TYPES', getAPIMethod('PerformanceManagementAlertEmailTitleType', 'loadAll'))
    }),


    performanceManagementAlerts = {
        ...entityActionSet(defaults.PerformanceManagementAlertReport, {
            loadAll: networkAction('LOAD_ALL_PERFORMANCE_MANAGEMENT_ALERTS', getAPIMethod('PerformanceManagementAlert', 'loadAllUnbatchedAlerts')),
            add: networkAction('ADD_PERFORMANCE_MANAGEMENT_ALERT', getAPIMethod('PerformanceManagementAlert', 'add')),
            edit: networkAction('EDIT_PERFORMANCE_MANAGEMENT_ALERT', getAPIMethod('PerformanceManagementAlert', 'edit')),
            delete: networkAction('DELETE_PERFORMANCE_MANAGEMENT_ALERT', getAPIMethod('PerformanceManagementAlert', 'delete')),
            voidAll: action('VOID_ALL_PERFORMANCE_MANAGEMENT_ALERTS')
        }),
        loadAlertBatchSlices: (alertIDs: number[], options: {startRow?: number; maxCount?: number; slicingOrder?: SortOrder;} = {}) =>
            networkAction(
                'LOAD_PERFORMANCE_MANAGEMENT_ALERT_BATCH_SLICES',
                { alertIDs, ...options },
                getAPIMethod<entities.NestedNetworkPaginationSlice<entities.PerformanceManagementAlertReport>[]>('PerformanceManagementAlert', 'loadAlertBatchSlices'),
                alertIDs,
                options
            ),
        sendPreview: (entityID: number, userID: number) => networkAction(
            'SEND_PERFORMANCE_MANAGEMENT_ALERT_PREVIEW', { entityID, userID }, getAPIMethod<entities.PerformanceManagementAlertReport>('PerformanceManagementAlert', 'sendPreview'), entityID, { userID }
        ),
        sendReview: (parentID: number, period: Date, coverLetter: string) => networkAction(
            'SEND_PERFORMANCE_MANAGEMENT_ALERT_REVIEW',
            { parentID, period, coverLetter },
            getAPIMethod<entities.PerformanceManagementAlertReport | null>('PerformanceManagementAlert', 'sendReview'),
            parentID,
            period,
            coverLetter
        ),
        sendReport: (parentID: number, period: Date, recipientUserIDs: number[], coverLetter: string) => networkAction(
            'SEND_PERFORMANCE_MANAGEMENT_ALERT_REPORT',
            { parentID, period, recipientUserIDs, coverLetter },
            getAPIMethod<entities.PerformanceManagementAlertReport | null>('PerformanceManagementAlert', 'sendReport'),
            recipientUserIDs,
            parentID,
            period,
            coverLetter
        ),
        evaluate: (entityID: number, score: number, comment: string) => networkAction(
            'EVALUATE_PERFORMANCE_MANAGEMENT_ALERT', { entityID, score, comment }, getAPIMethod<entities.PerformanceManagementAlertReport>('PerformanceManagementAlert', 'evaluate'), entityID, score, comment
        ),
        reviewAndSend: (parentID: number, batch: entities.PerformanceManagementAlertReport) =>
            networkAction(
                'REVIEW_AND_SEND_PERFORMANCE_MANAGEMENT_ALERT_BATCH',
                { parentID, entityID: batch.ID, batch },
                getAPIMethod<entities.PerformanceManagementAlertReport>('PerformanceManagementAlert', 'reviewAndSend'),
                batch
            ),
        createLoginURL: (parentID: number, batchID: number, userID: number) =>
            networkAction(
                'CREATE_PERFORMANCE_MANAGEMENT_ALERT_BATCH_USER_LOGIN_URL',
                { parentID, entityID: batchID, userID },
                getAPIMethod<string>('PerformanceManagementAlert', 'createLoginURL'),
                batchID,
                userID
            )
    },

    performanceManagementAlertRecipients =
        entityActionSet(defaults.PerformanceManagementAlertReport, defaults.PerformanceManagementAlertRecipient, {
            addAll: networkAction('ADD_ALL_PERFORMANCE_MANAGEMENT_ALERT_RECIPIENTS', getAPIMethod('PerformanceManagementAlertRecipient', 'addAll')),
            deleteAll: networkAction('DELETE_ALL_PERFORMANCE_MANAGEMENT_ALERT_RECIPIENTS', getAPIMethod('PerformanceManagementAlertRecipient', 'deleteAll'))
        }),

    performanceManagementAlertTriggerIndicators =
        entityActionSet(defaults.PerformanceManagementAlertReport, defaults.PerformanceManagementAlertTriggerIndicator, {
            addAll: networkAction('ADD_ALL_PERFORMANCE_MANAGEMENT_ALERT_TRIGGER_INDICATORS', getAPIMethod('PerformanceManagementAlertTriggerIndicator', 'addAll')),
            editAll: networkAction('EDIT_ALL_PERFORMANCE_MANAGEMENT_ALERT_TRIGGER_INDICATORS', getAPIMethod('PerformanceManagementAlertTriggerIndicator', 'editAll')),
            deleteAll: networkAction('DELETE_ALL_PERFORMANCE_MANAGEMENT_ALERT_TRIGGER_INDICATORS', getAPIMethod('PerformanceManagementAlertTriggerIndicator', 'deleteAll'))
        }),

    performanceManagementAlertIndicators =
        entityActionSet(defaults.PerformanceManagementAlertReport, defaults.PerformanceManagementAlertIndicator, {
            addAll: networkAction('ADD_ALL_PERFORMANCE_MANAGEMENT_ALERT_INDICATORS', getAPIMethod('PerformanceManagementAlertIndicator', 'addAll')),
            editAll: networkAction('EDIT_ALL_PERFORMANCE_MANAGEMENT_ALERT_INDICATORS', getAPIMethod('PerformanceManagementAlertIndicator', 'editAll')),
            deleteAll: networkAction('DELETE_ALL_PERFORMANCE_MANAGEMENT_ALERT_INDICATORS', getAPIMethod('PerformanceManagementAlertIndicator', 'deleteAll'))
        }),

    performanceManagementAlertReviewSections =
        entityActionSet(defaults.PerformanceManagementAlertReport, defaults.PerformanceManagementAlertReviewSectionReport, {
            add: networkAction('ADD_PERFORMANCE_MANAGEMENT_ALERT_REVIEW_SECTION', getAPIMethod('PerformanceManagementAlertReviewSection', 'add')),
            edit: networkAction('EDIT_PERFORMANCE_MANAGEMENT_ALERT_REVIEW_SECTION', getAPIMethod('PerformanceManagementAlertReviewSection', 'edit')),
            delete: networkAction('DELETE_PERFORMANCE_MANAGEMENT_ALERT_REVIEW_SECTION', getAPIMethod('PerformanceManagementAlertReviewSection', 'delete'))
        }),

    performanceManagementAlertReviewSectionComments =
        entityActionSet(
            defaults.PerformanceManagementAlertReport,
            defaults.PerformanceManagementAlertReviewSectionReport,
            defaults.PerformanceManagementAlertReviewSectionComment,
            {
                addAll: networkAction('ADD_ALL_PERFORMANCE_MANAGEMENT_ALERT_REVIEW_SECTION_COMMENTS', getAPIMethod('PerformanceManagementAlertReviewSectionComment', 'addAll')),
                editAll: networkAction('EDIT_ALL_PERFORMANCE_MANAGEMENT_ALERT_REVIEW_SECTION_COMMENTS', getAPIMethod('PerformanceManagementAlertReviewSectionComment', 'editAll'))
            }
        ),

    performanceManagementAlertDashboardBlocks =
        entityActionSet(defaults.PerformanceManagementAlertReport, defaults.PerformanceManagementAlertDashboardBlockReport, {
            addAll: networkAction('ADD_ALL_PERFORMANCE_MANAGEMENT_ALERT_DASHBOARD_BLOCKS', getAPIMethod('PerformanceManagementAlertDashboardBlock', 'addAll')),
            add: networkAction('ADD_PERFORMANCE_MANAGEMENT_ALERT_DASHBOARD_BLOCK', getAPIMethod('PerformanceManagementAlertDashboardBlock', 'add')),
            editAll: networkAction('EDIT_ALL_PERFORMANCE_MANAGEMENT_ALERT_DASHBOARD_BLOCKS', getAPIMethod('PerformanceManagementAlertDashboardBlock', 'editAll')),
            edit: networkAction('EDIT_PERFORMANCE_MANAGEMENT_ALERT_DASHBOARD_BLOCK', getAPIMethod('PerformanceManagementAlertDashboardBlock', 'edit')),
            deleteAll: networkAction('DELETE_ALL_PERFORMANCE_MANAGEMENT_ALERT_DASHBOARD_BLOCKS', getAPIMethod('PerformanceManagementAlertDashboardBlock', 'deleteAll')),
            delete: networkAction('DELETE_PERFORMANCE_MANAGEMENT_ALERT_DASHBOARD_BLOCK', getAPIMethod('PerformanceManagementAlertDashboardBlock', 'delete'))
        }),

    performanceManagementAlertDashboardBlockComments =
        entityActionSet(
            defaults.PerformanceManagementAlertReport,
            defaults.PerformanceManagementAlertDashboardBlockReport,
            defaults.PerformanceManagementAlertDashboardBlockComment,
            {
                addAll: networkAction('ADD_ALL_PERFORMANCE_MANAGEMENT_ALERT_DASHBOARD_BLOCK_COMMENTS', getAPIMethod('PerformanceManagementAlertDashboardBlockComment', 'addAll')),
                editAll: networkAction('EDIT_ALL_PERFORMANCE_MANAGEMENT_ALERT_DASHBOARD_BLOCK_COMMENTS', getAPIMethod('PerformanceManagementAlertDashboardBlockComment', 'editAll'))
            }
        );

export type AlertsAction = ExtractAction<
| typeof loadAllPerformanceManagementAlertActivityStatuses
| typeof loadAllPerformanceManagementAlertTriggerTypes
| typeof loadAllPerformanceManagementAlertScores
| typeof loadAllPerformanceManagementAlertEmailTitleTypes
| typeof performanceManagementAlerts
| typeof performanceManagementAlertRecipients
| typeof performanceManagementAlertTriggerIndicators
| typeof performanceManagementAlertIndicators
| typeof performanceManagementAlertReviewSections
| typeof performanceManagementAlertReviewSectionComments
| typeof performanceManagementAlertDashboardBlocks
| typeof performanceManagementAlertDashboardBlockComments
>;
